<template>
	<div
		v-if="loaded"
		class="sal-components-etf-quote-bottom"
	>
		<sal-components-pillar-cards-price
			:international-request-templates="internationalRequestTemplates"
			class="sal-components-pillar-cards-price__wrapper sal-component"
			mwc-id="salPillarCardsPrice"
		/>

		<sal-components-mip-esg
			class="sal-components-mip-esg__wrapper sal-component"
			mwc-id="salMipEsg"
		/>

		<sal-components-mip-strategy
			class="sal-components-mip-strategy__wrapper sal-component"
			mwc-id="salMipStrategy"
			:enable-security-hyperlinks="true"
		/>
	</div>
</template>

<script>
import SalComponentsMipEsg from '@sal/mip-esg-shell';
import SalComponentsMipStrategy from '@sal/mip-strategy';
import SalComponentsPillarCardsPrice from '@sal/pillar-cards-price';
import SalCommonMixin from '@/mixins/sal-common';

export default {
	name: 'quote-bottom',
	components: {
		SalComponentsMipEsg,
		SalComponentsMipStrategy,
		SalComponentsPillarCardsPrice
	},
	mixins: [SalCommonMixin]
};
</script>

<style lang="scss" scoped>
::v-deep .sal-components-mip-esg__wrapper .flag-root {
	height: auto !important;
}

::v-deep .sal-components-pillar-cards-price__wrapper {
	@media (min-width: 1000px) {
		.mds-layout-grid__sal .mds-layout-grid__col--3-at-1000__sal {
			flex-basis: 50% !important;
			flex-grow: 0 !important;
			flex-shrink: 0 !important;
			max-width: 50% !important;
		}

		.mds-layout-grid__sal .mds-layout-grid__col--6-at-1000__sal {
			flex-basis: 100% !important;
			flex-grow: 0 !important;
			flex-shrink: 0 !important;
			max-width: 100% !important;
		}
	}
}
</style>
